export default function assetInformationColumnsSpecificataion(config) {
    if (!config.data) return null;
    const { assetList = [], isFileUploaded = false } = config.data;

    let result = {};
    let tableData = [];

    assetList.forEach((asset, index) => {
        let row = [];
        const rowId = `row-${index}`;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;

            let columnValue = null;
            if (columnDataType === "string") {
                if (columnId === "assetType") {
                    columnValue = asset.assetType;
                }
                if (columnId === "totalAssetsQuoted") {
                    columnValue = asset.quotedQuantity !== null ?  asset.quotedQuantity : asset.quantity;
                }
                if (columnId === "totalAssetsCollected") {
                    let collectedQuantity = asset.collectedQuantity || '';
                    if (isFileUploaded && !collectedQuantity) {
                        collectedQuantity = 0;
                    }
                    columnValue = collectedQuantity
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
